const sensorsLocale = {
  sensors: {
    title: "Capteurs de température",
    sensor: "Capteur",
    sensors: "Capteurs",
    temperatureSensor: "Capteur de température",
    temperatureSensors: "Capteurs de température",
    activeInSite: "Actif sur site",
    linkedToSensors: "Liés à un capteur",
    sentByCustomerServer: "Envoyés par les téléconseillers",
    nSensorsSent: "{n} Capteurs envoyés",
    request: "Demande d'envoie de capteurs",
    noModulators: "Aucun matériel",
    noModulatorsWarning:
      "Aucun matériel n'est installé sur site. Impossible de faire une demande d'envoie de capteurs sur un site sans matériel.",
    beforeShipment: "Avant tout envoi de matériel:",
    beforeShipmentList: `
            <li>Envoyer des capteurs de température seulement si nécessaire (après diagnostic)</li>
            <li>Vérifier l'adresse postale, le numéro de téléphone principal et l'adresse mail</li>
            <li>Le matériel est envoyé sous 5 jours ouvrés à l'adresse renseignée sur VoltaCall</li>
            <li>L'adhérent doit posséder un smartphone avec appareil photo et l'application MyVoltalis à jour</li>
            <li>Dans le colis, l'adhérent trouvera un court mode opératoire pour installer ses capteurs</li>
        `,
    form: {
      number: "Nombre de capteurs à envoyer",
      rooms: "Sélectionnez les appareils concernés par l'envoi de capteurs",
    },
  },
};

export type SensorsLocale = typeof sensorsLocale;
export default sensorsLocale;
